import React, { useState } from "react";
import { Button } from "../../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog";
import { Label } from "../../../components/ui/label";
import { Input } from "../../../components/ui/input";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../components/ui/select";
import { Plus } from "lucide-react";

export function AddSymbolModal({ handleAddSymbol }) {
  const [open, setOpen] = useState(false);

  const productOptions = [
    { value: "pledge_plus", title: "pledge_plus" },
    { value: "pledge_plus_mini", title: "pledge_plus_mini" },
  ];

  const categoryOptions = [
    { value: "commodity", title: "commodity" },
    { value: "index", title: "index" },
  ];

  const [symbolName, setSymbolName] = useState("");
  const [product, setProduct] = useState("pledge_plus");
  const [category, setCategory] = useState("index");

  const handleSubmit = () => {
    const symbolStr = symbolName.trim();
    if (!symbolStr) {
      return alert("Please enter a symbol name");
    }
    handleAddSymbol(symbolStr, product, category);
    setSymbolName("");
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="bg-blue-600 hover:bg-blue-700 text-white font-medium text-[15px] flex items-center gap-1.5 px-4 rounded-lg">
          <Plus className="w-4 h-4" />
          Add Symbol
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[525px] border-zinc-700 bg-black">
        <DialogHeader>
          <DialogTitle className="text-white">Add Pledge Plus Symbol</DialogTitle>
          <DialogDescription className="text-zinc-400">
            Fill in the symbol configuration below to add it to the tracking database.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-1 items-center gap-2">
            <Label className="text-white">Symbol Name</Label>
            <Input
              type="text"
              placeholder="e.g. NSE:NIFTY26MARFUT"
              value={symbolName}
              onChange={(e) => setSymbolName(e.target.value)}
              className="bg-[#1A1A1A] text-white border-zinc-700 focus:outline-none focus:border-blue-500 placeholder-zinc-500"
            />
          </div>

          <div className="grid grid-cols-1 items-center gap-2">
            <Label className="text-white">Product</Label>
            <Select
              value={product}
              onValueChange={(value) => setProduct(value)}
            >
              <SelectTrigger className="text-white text-[15px] hover:bg-zinc-800 bg-[#1A1A1A] border-zinc-700">
                <SelectValue placeholder="Select Product" />
              </SelectTrigger>
              <SelectContent className="border-zinc-700">
                <SelectGroup>
                  {productOptions.map((item) => (
                    <SelectItem key={item.value} value={item.value}>
                      {item.title}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>

          <div className="grid grid-cols-1 items-center gap-2">
            <Label className="text-white">Category</Label>
            <Select
              value={category}
              onValueChange={(value) => setCategory(value)}
            >
              <SelectTrigger className="text-white text-[15px] hover:bg-zinc-800 bg-[#1A1A1A] border-zinc-700">
                <SelectValue placeholder="Select Category" />
              </SelectTrigger>
              <SelectContent className="border-zinc-700">
                <SelectGroup>
                  {categoryOptions.map((item) => (
                    <SelectItem key={item.value} value={item.value}>
                      {item.title}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button
            type="button"
            className="text-[15px] font-medium bg-blue-600 hover:bg-blue-700 text-white"
            onClick={handleSubmit}
          >
            Add Symbol to Table
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
